import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { FormControl, FormHelperText, Alert, Button, Snackbar, MenuItem, Menu, Select, IconButton, Container, Typography, CircularProgress, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Chip, TablePagination } from '@mui/material';
import { useState, useEffect } from "react";
import { api } from "../../../services/api";
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import ListAltIcon from '@mui/icons-material/ListAlt';
import BusinessIcon from '@mui/icons-material/Business';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import PersonIcon from '@mui/icons-material/Person';
import { Check, Close, Delete, Edit, MoreVert } from '@mui/icons-material';
import DeleteStaffModal from '../../../components/modales/DeleteStaffModal';
import BannerPreview from '../../../components/evento/BannerPreview';

export const AgregarColaboradores = ({ eventId, isPublic }) => {
  const [state, setState] = useState({
    showResult: false,
    apiMessage: "",
    error: null,
  });
  const [evento, setEvento] = useState();
  const [colaboradores, setColaboradores] = useState([]);
  const [subrol, setSubrol] = useState("");
  const [email, setEmail] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [errorMail, setErrorMail] = useState(false);
  const [errorRol, setErrorRol] = useState(false);
  const [error, setError] = useState("");

  const [loadingColaboradores, setLoadingColaboradores] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedMember, setSelectedMember] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [memberToDelete, setMemberToDelete] = useState(null);
  const [editingMember, setEditingMember] = useState(null);
  const [editedSubrole, setEditedSubrole] = useState(null);
  const [toast, setToast] = useState({
    open: false,
    message: '',
    severity: "success"
  });

  //roles
  const roleOptions = [
    {
      value: 'owner',
      label: 'Owner',
      icon: <SupervisorAccountIcon style={{ color: "#067bea" }} />,
      description: 'Acceso completo a todas las funciones y configuraciones del evento.'
    },
    {
      value: 'cliente',
      label: 'Cliente',
      icon: <PersonIcon style={{ color: "#067bea" }} />,
      description: 'Acceso únicamente a reportes, estadísticas y seguimiento del evento'
    },
    {
      value: 'colaborador',
      label: 'Colaborador',
      icon: <ListAltIcon style={{ color: "#067bea" }} />,
      description: 'Acceso limitado según el tipo de colaborador seleccionado.'
    },
    {
      value: 'expositor',
      label: 'Expositor',
      icon: <BusinessIcon style={{ color: "#067bea" }} />,
      description: 'Permite registrar información de asistentes mediante el escaneo de sus tickets de ingreso.'
    }
  ];

  // subroles
  const colaboradorRoles = [
    {
      value: 0,
      label: "Colaborador General",
      icon: <ListAltIcon style={{ color: "#067bea" }} />,
      description: "Rol encargado de diversas tareas como controlar el acceso y los vouchers."
    },
    {
      value: 2,
      label: "Control de Acceso",
      icon: <QrCodeScannerIcon style={{ color: "#067bea" }} />,
      description: "Rol encargado de controlar el acceso de las personas autorizadas al evento."
    },
    {
      value: 3,
      label: "Control de Voucher",
      icon: <QrCodeScannerIcon style={{ color: "#067bea" }} />,
      description: "Rol encargado de controlar y gestionar el canje de los vouchers del evento."
    },
    {
      value: 7,
      label: "Administrador de datos",
      icon: <ListAltIcon style={{ color: "#067bea" }} />,
      description: "Rol encargado de la carga y diseño de tickets."
    }
  ];

  const fetchEventData = async () => {
    setLoadingColaboradores(true);
    try {
      const response = await api.eventos.get(eventId);
      if (response.status === "success") {
        setEvento(response.data.evento);

        const responseParticipaciones = await api.participaciones.getParticipacionesByEvento(eventId);
        if (responseParticipaciones.status === "success") {
          const participaciones = responseParticipaciones.data.participaciones.map(p => {
            const isCollab = [2, 5, 6, 7].includes(p.idrol);
            return {
              id: p.id,
              idusuario: p.idusuario,
              idrol: p.idrol,
              rolTipo: isCollab ? "Colaborador" : (p.rol?.rol || obtenerNombreRol(p.idrol)),
              nombreUsuario: p.usuario?.usuario || "",
              nombre: p.usuario?.nombre || "",
              apellido: p.usuario?.apellido || "",
              email: p.usuario?.usuario || "",
              idestado: p.idestado || 2,
              rolId: p.idrol,
              aceptado: p.idestado === 2,
              estado: {
                idestado: p.idestado || 2,
                estado: p.idestado === 2 ? "Aceptado" : "Pendiente"
              }
            };
          });

          setColaboradores(participaciones);
        }
      }
    } catch (error) {
      setState({
        ...state,
        error: "Error en la Red.",
      });
    } finally {
      setLoadingColaboradores(false);
    }
  };

  useEffect(() => {
    fetchEventData();
  }, [eventId]);

  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes pulse {
        0% { opacity: 0.6; }
        50% { opacity: 0.3; }
        100% { opacity: 0.6; }
      }
    `;
    document.head.appendChild(style);
    return () => { document.head.removeChild(style); };
  }, []);

  const obtenerNombreRol = (idRol) => {
    switch (idRol) {
      case 1: return "Owner";
      case 2: return "Colaborador General";
      case 3: return "Cliente";
      case 5: return "Control de Acceso";
      case 6: return "Control de Voucher";
      case 7: return "Administrador de datos";
      case 8: return "Expositor";
      default: return "Desconocido";
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    if (email === "") {
      setErrorMail(true);
      setSubmitting(false);
      return;
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      setError("Introduce un correo electrónico válido");
      setSubmitting(false);
      return;
    }

    if (selectedRole === "") {
      setErrorRol(true);
      setSubmitting(false);
      return;
    }

    if (selectedRole === 'colaborador' && subrol === "") {
      setError("Debes seleccionar un tipo de colaborador");
      setSubmitting(false);
      return;
    }

    try {
      const verificarResponse = await api.usuarios.getUserExist(email);

      if (verificarResponse.status === "error") {
        setError("El usuario con este correo no está registrado. Por favor, indique al usuario que se registre primero.");
        setSubmitting(false);
        return;
      }

      const usuario = verificarResponse.data.usuario;

      let idRol;
      let subrolId = null;

      switch (selectedRole) {
        case 'owner':
          idRol = 1;
          break;
        case 'cliente':
          idRol = 3;
          break;
        case 'colaborador':
          subrolId = parseInt(subrol);
          if (subrolId === 0) idRol = 2;
          else if (subrolId === 2) idRol = 5;
          else if (subrolId === 3) idRol = 6;
          else if (subrolId === 7) idRol = 7;
          break;
        case 'expositor':
          idRol = 8;
          break;
        default:
          setError("Rol no válido");
          setSubmitting(false);
          return;
      }

      const participacionData = {
        idevento: parseInt(eventId),
        idusuario: usuario.id,
        idrol: idRol,
        email: email,
        subrol: subrolId
      };

      const response = await api.participaciones.createParticipacion(participacionData);

      if (response.status === "error") {
        setError("Error: " + response.message);
        setSubmitting(false);
        return;
      }

      if (response.status === "success") {
        setSubmitting(false);
        setSubmitted(true);
        setError("");
        setSelectedRole("");
        setSubrol("");
        setEmail("");

        const emailData = {
          recipient: email,
          evento: evento.evento,
          rol: selectedRole
        };
        await api.email.send(emailData);

        setToast({
          open: true,
          message: 'Miembro agregado correctamente',
          severity: 'success'
        });

        setTimeout(() => {
          fetchEventData();
        }, 500);
      }
    } catch (error) {
      setError("Error: " + (error.message || "Ha ocurrido un error"));
      setSubmitting(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleMenuOpen = (event, member) => {
    setMenuAnchorEl(event.currentTarget);
    setSelectedMember(member);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const isCollaboratorRole = (rolId) => {
    const collaboratorRoleIds = [2, 5, 6, 7];
    return collaboratorRoleIds.includes(parseInt(rolId));
  };

  const handleDeleteMember = () => {
    if (selectedMember) {
      let memberType = '';

      switch (selectedMember.rolTipo) {
        case 'Owner':
          memberType = 'owner';
          break;
        case 'Cliente':
          memberType = 'cliente';
          break;
        case 'Expositor':
          memberType = 'expositor';
          break;
        default:
          memberType = 'colaborador';
          break;
      }

      setMemberToDelete({
        id: selectedMember.id,
        type: memberType,
        name: `${selectedMember.nombre || ""} ${selectedMember.apellido || ""}`.trim() || selectedMember.email
      });
      setDeleteModalOpen(true);
      handleMenuClose();
    }
  };

  const handleDeleteSuccess = () => {
    fetchEventData();
    setToast({
      open: true,
      message: 'Miembro eliminado correctamente',
      severity: 'success'
    });
  };

  const handleDeleteError = (errorMsg) => {
    setToast({
      open: true,
      message: `Error al eliminar: ${errorMsg || 'Error desconocido'}`,
      severity: 'error'
    });
  };

  const handleEdit = () => {
    if (selectedMember && isCollaboratorRole(selectedMember.rolId)) {
      setEditingMember(selectedMember.id);

      let subrolValue;
      switch (parseInt(selectedMember.rolId)) {
        case 2: subrolValue = 0; break;
        case 5: subrolValue = 2; break;
        case 6: subrolValue = 3; break;
        case 7: subrolValue = 7; break;
        default: subrolValue = 0;
      }

      setEditedSubrole(subrolValue);
      handleMenuClose();
    } else {
      setToast({
        open: true,
        message: 'Solo se pueden editar los roles de colaboradores',
        severity: 'info'
      });
      handleMenuClose();
    }
  };

  const handleSaveEdit = async (member) => {
    try {
      setSubmitting(true);

      let nuevoIdRol;
      switch (parseInt(editedSubrole)) {
        case 0: nuevoIdRol = 2; break;
        case 2: nuevoIdRol = 5; break;
        case 3: nuevoIdRol = 6; break;
        case 7: nuevoIdRol = 7; break;
        default: nuevoIdRol = 2;
      }

      if (member.rolId === nuevoIdRol) {
        setEditingMember(null);
        setSubmitting(false);
        return;
      }

      const response = await api.participaciones.updateSubrol({
        idparticipacion: member.id,
        newRol: nuevoIdRol,
        newSubrol: parseInt(editedSubrole)
      });

      if (response.status === "success") {
        setColaboradores(prevMembers =>
          prevMembers.map(m =>
            m.id === member.id ? {
              ...m,
              rolId: nuevoIdRol,
              idrol: nuevoIdRol
            } : m
          )
        );

        setEditingMember(null);
        setSubmitting(false);

        setToast({
          open: true,
          message: 'Rol actualizado correctamente',
          severity: 'success'
        });
      } else {
        throw new Error(response.message || "Error al actualizar");
      }
    } catch (error) {
      setError("Error al actualizar: " + error.message);
      setSubmitting(false);
      setToast({
        open: true,
        message: 'Error al actualizar el rol',
        severity: 'error'
      });
    }
  };

  const handleCancelEdit = () => {
    setEditingMember(null);
  };

  const handleCloseToast = () => {
    setToast({ ...toast, open: false });
  };

  const getSubrolText = (rolId) => {
    switch (parseInt(rolId)) {
      case 2: return "Colaborador General";
      case 5: return "Control de Acceso";
      case 6: return "Control de Voucher";
      case 7: return "Administrador de datos";
      case 1: return "Owner";
      case 3: return "Cliente";
      case 8: return "Expositor";
      default: return "General";
    }
  };

  const displayedMiembros = colaboradores?.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const renderRolCell = (member) => {
    if (editingMember === member.id && isCollaboratorRole(member.rolId)) {
      return (
        <FormControl size="small" fullWidth>
          <Select
            value={editedSubrole}
            onChange={(e) => setEditedSubrole(e.target.value)}
            sx={{
              fontFamily: "Bricolage Grotesque",
              height: '32px',
              '.MuiSelect-select': {
                padding: '4px 10px',
              },
              '&.MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: '#B2BAC2',
                },
                '&:hover fieldset': {
                  borderColor: '#5656ff',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#5656ff',
                },
              }
            }}
          >
            {colaboradorRoles.map((role) => (
              <MenuItem key={role.value} value={role.value}>
                {role.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      );
    }

    return <span>{getSubrolText(member.rolId)}</span>;
  };

  const renderActionButton = (member) => {
    if (editingMember === member.id) {
      return (
        <div className="d-flex justify-content-end">
          <IconButton
            onClick={() => handleSaveEdit(member)}
            disabled={submitting}
            sx={{ color: '#5656ff' }}
          >
            <Check />
          </IconButton>
          <IconButton
            onClick={handleCancelEdit}
            sx={{ color: '#FF5656' }}
          >
            <Close />
          </IconButton>
        </div>
      );
    }

    return (
      <IconButton
        aria-label="opciones"
        onClick={(e) => handleMenuOpen(e, member)}
        sx={{ color: '#5656ff' }}
      >
        <MoreVert />
      </IconButton>
    );
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" sx={{ fontFamily: "Bricolage Grotesque", color: "#0b0062", mb: 2 }}>
          Agregar miembros a tu evento
        </Typography>
        <Typography variant="body1" sx={{ color: "#4b4d63", mb: 4 }}>
          Añade miembros a tu evento para que te ayuden a gestionarlo. Puedes asignarles diferentes roles según las tareas que necesites que realicen.
        </Typography>
      </Box>

      <Box component="form" onSubmit={handleSubmit} sx={{ mb: 5 }}>
        <TextField
          sx={{
            fontFamily: "Bricolage Grotesque",
            mb: 2,
            '& label.Mui-focused': {
              color: '#5656FF',
            },
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#B2BAC2',
              },
              '&:hover fieldset': {
                borderColor: '#5656ff',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#5656ff',
              },
            }
          }}
          name="email"
          label="Correo electrónico"
          variant="outlined"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          error={errorMail}
          helperText={errorMail ? "Ingrese un correo electrónico" : ""}
          fullWidth
          margin="normal"
        />

        <FormControl error={errorRol} sx={{ width: '100%', mt: 3 }}>
          <Typography variant="subtitle1" sx={{ mb: 2, fontFamily: "Bricolage Grotesque", color: "#0b0062" }}>
            Selecciona un rol para el miembro
          </Typography>
          <div className="row">
            {roleOptions.map((role) => (
              <div key={role.value} className="col-md-3 col-sm-6 mb-3">
                <button
                  type="button"
                  onClick={() => {
                    setSelectedRole(role.value);
                    if (role.value !== 'colaborador') setSubrol("");
                  }}
                  className={`w-100 boton-tipo ${selectedRole === role.value ? 'boton-tipo-active' : ''}`}
                  style={{
                    border: selectedRole === role.value ? '1px solid #5656ff' : '1px solid #ccc',
                    borderRadius: '8px',
                    padding: '16px',
                    background: selectedRole === role.value ? '#e6e6ff' : 'white',
                    cursor: 'pointer',
                    textAlign: 'left',
                    height: '100%',
                  }}
                >
                  <div className='d-flex flex-column'>
                    <span className="d-flex align-items-center" style={{ fontWeight: "bold", color: "#0b0062" }}>
                      {role.icon} <span className="ml-2">{role.label}</span>
                    </span>
                    <span style={{ fontSize: "13px", color: "#4b4d63" }}>{role.description}</span>
                  </div>
                </button>
              </div>
            ))}
          </div>
          {errorRol && (
            <FormHelperText>Por favor, seleccione un rol</FormHelperText>
          )}
        </FormControl>

        {selectedRole === 'colaborador' && (
          <FormControl sx={{ width: '100%', mt: 3 }}>
            <Typography variant="subtitle1" sx={{ mb: 2, fontFamily: "Bricolage Grotesque", color: "#0b0062" }}>
              Selecciona un tipo de colaborador
            </Typography>
            <div className="row">
              {colaboradorRoles.map((role) => (
                <div key={role.value} className="col-md-3 col-sm-6 mb-3">
                  <button
                    type="button"
                    onClick={() => setSubrol(role.value)}
                    className={`w-100 boton-tipo ${subrol === role.value ? 'boton-tipo-active' : ''}`}
                    style={{
                      border: subrol === role.value ? '1px solid #5656ff' : '1px solid #ccc',
                      borderRadius: '8px',
                      padding: '16px',
                      background: subrol === role.value ? '#e6e6ff' : 'white',
                      cursor: 'pointer',
                      textAlign: 'left',
                      height: '100%',
                    }}
                  >
                    <div className='d-flex flex-column'>
                      <span className="d-flex align-items-center" style={{ fontWeight: "bold", color: "#0b0062" }}>
                        {role.icon} <span className="ml-2">{role.label}</span>
                      </span>
                      <span style={{ fontSize: "13px", color: "#4b4d63" }}>{role.description}</span>
                    </div>
                  </button>
                </div>
              ))}
            </div>
          </FormControl>
        )}

        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>
        )}

        {submitting && (
          <Alert icon={false} severity="info" sx={{ mt: 2 }}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <CircularProgress size="20px" />
              Procesando solicitud...
            </div>
          </Alert>
        )}

        {submitted && (
          <Alert severity="success" sx={{ mt: 2 }}>
            Se ha enviado una invitación al miembro
          </Alert>
        )}

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
          <Button
            variant="contained"
            type="submit"
            disabled={submitting || !email || !selectedRole || (selectedRole === 'colaborador' && !subrol)}
            sx={{
              bgcolor: '#5656ff',
              fontFamily: "Bricolage Grotesque",
              '&:hover': { bgcolor: '#4545ee' },
              '&.Mui-disabled': {
                bgcolor: '#e0e0e0',
                color: '#ababab'
              }
            }}
          >
            {submitting ? 'Procesando...' : 'Agregar miembro'}
          </Button>
        </Box>
      </Box>

      <Typography variant="h6" component="h2" gutterBottom sx={{
        fontFamily: "Bricolage Grotesque",
        color: "#0B0060",
        fontSize: "20px",
        fontWeight: "600",
        mt: 4
      }}>
        Miembros del evento
      </Typography>

      <TableContainer component={Paper} sx={{
        mt: 2,
        borderRadius: '12px',
        boxShadow: '0px 2px 8px rgba(0,0,0,0.08)',
        border: '1px solid #E6E6FF',
        mb: 4
      }}>
        <Table aria-label="tabla de miembros">
          <TableHead sx={{ backgroundColor: "#E6E6FF" }}>
            <TableRow>
              <TableCell sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque" }}>Nombre</TableCell>
              <TableCell sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque" }}>Email</TableCell>
              <TableCell sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque" }}>Rol</TableCell>
              <TableCell sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque" }}>Estado</TableCell>
              <TableCell sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque" }} align="right"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loadingColaboradores ? (
              Array(3).fill(0).map((_, index) => (
                <TableRow key={`skeleton-${index}`}>
                  {[...Array(5)].map((_, cellIdx) => (
                    <TableCell key={cellIdx}>
                      <div style={{
                        backgroundColor: '#f0f0f5',
                        height: '24px',
                        width: cellIdx === 1 ? '70%' : '90%',
                        borderRadius: '4px',
                        animation: 'pulse 1.5s infinite ease-in-out'
                      }}></div>
                    </TableCell>
                  ))}
                </TableRow>
              ))
            ) : colaboradores?.length > 0 ? (
              displayedMiembros.map((member) => (
                <TableRow key={member.id} hover sx={{ '&:hover': { backgroundColor: '#F5F7FF' } }}>
                  <TableCell sx={{ fontFamily: "Bricolage Grotesque", color: "#0b0060" }}>
                    {`${member.nombre || ""} ${member.apellido || ""}`.trim() || "Pendiente"}
                  </TableCell>
                  <TableCell sx={{ fontFamily: "Bricolage Grotesque", color: "#0b0060" }}>
                    {member.email}
                  </TableCell>
                  <TableCell sx={{ fontFamily: "Bricolage Grotesque" }}>
                    {renderRolCell(member)}
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={member.estado?.estado || (member.aceptado ? "Aceptado" : "Pendiente")}
                      size="small"
                      sx={{
                        bgcolor: member.aceptado ? '#B6FECB' : '#FFE3B3',
                        color: member.aceptado ? '#216735' : '#664D03',
                        fontWeight: 500,
                        minWidth: '80px',
                        fontFamily: "Bricolage Grotesque"
                      }}
                    />
                  </TableCell>
                  <TableCell align="right">
                    {renderActionButton(member)}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <Alert severity="info" sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    fontFamily: "Bricolage Grotesque"
                  }}>
                    No hay miembros registrados para este evento
                  </Alert>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        {!loadingColaboradores && colaboradores?.length > 0 && (
          <TablePagination
            component="div"
            count={colaboradores.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
            labelRowsPerPage="Por página"
            sx={{
              fontFamily: "Bricolage Grotesque",
              '& .MuiToolbar-root': {
                color: '#71717A',
              }
            }}
          />
        )}
      </TableContainer>

      <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handleMenuClose}
        sx={{
          '& .MuiPaper-root': {
            boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
            borderRadius: '5px',
          },
          '& .MuiMenuItem-root': {
            fontFamily: 'Bricolage Grotesque',
            fontSize: '16px',
            padding: '8px 16px',
          }
        }}
      >
        <MenuItem
          onClick={handleEdit}
          disabled={!selectedMember || !isCollaboratorRole(selectedMember?.rolId)}
          sx={{
            opacity: selectedMember && isCollaboratorRole(selectedMember?.rolId) ? 1 : 0.5,
            '&.Mui-disabled': {
              color: '#9e9e9e',
            }
          }}
        >
          <Edit sx={{
            marginRight: "10px",
            color: selectedMember && isCollaboratorRole(selectedMember?.rolId) ? "#5656ff" : "#9e9e9e"
          }} />
          Editar rol
        </MenuItem>
        <MenuItem onClick={handleDeleteMember}>
          <Delete sx={{ marginRight: "10px", color: "#FF5656" }} />
          Eliminar
        </MenuItem>
      </Menu>

      {memberToDelete && (
        <DeleteStaffModal
          isOpen={deleteModalOpen}
          toggle={() => setDeleteModalOpen(false)}
          id={memberToDelete.id}
          memberType={memberToDelete.type}
          memberName={memberToDelete.name}
          onSuccess={handleDeleteSuccess}
          onError={handleDeleteError}
        />
      )}

      {isPublic && eventId && <BannerPreview eventId={eventId} />}
      <Snackbar
        open={toast.open}
        autoHideDuration={5000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleCloseToast}
          severity={toast.severity}
          variant="filled"
          sx={{ width: '100%', fontFamily: 'Bricolage Grotesque' }}
        >
          {toast.message}
        </Alert>
      </Snackbar>
    </Container>
  );
}